<template>
  <b-tooltip :target="target" triggers="hover">
    <div class="text-left">
      <div v-if="tagCloud" class="m-3">
        <tag-badge :resource="{ origin: 'dicom', value: 'tag' }"></tag-badge> DICOM<br /><br />
        <tag-badge :resource="{ origin: 'user', value: 'tag' }"></tag-badge> Question<br /><br />
        <tag-badge :resource="{ origin: 'user', value: 'tag', isReplyTag: true }"></tag-badge> Reply
      </div>
      <div v-if="karma" class="m-3">Karma points you have collected in total</div>
    </div>
    <slot></slot>
  </b-tooltip>
</template>

<script>
  export default {
    name: 'HelpTooltip',

    components: {
      TagBadge: () => import('@/Atoms/TagBadge'),
    },

    props: {
      target: String,
      tagCloud: Boolean,
      karma: Boolean,
    },
  };
</script>
